export default (value) => {
  if (!/[0-9]/.test(value)) {
    return "A senha deve conter pelo menos um número.";
  }
  if (!/[!@#$%^&*()\-,.?":{}|<>]/.test(value)) {
    return "A senha deve conter pelo menos um caractere especial.";
  }
  return true;
};
